import React from 'react'
import {ShowableProductCard} from 'ReactApp/Ddd/Aggregates/ShowableProductCard';
import {observer} from "mobx-react";
import {PluralFormat} from "../../Services/Formatters/PluralFormatter";
import LinkV1 from "../LinkV1/LinkV1";

const sentence = {
    visible: {
        transition: {
            delay: 1,
            staggerChildren: 0.05,
            staggerDirection: 1,
        },
    },
}
type PopularInfoV1Props = {
    productCard: ShowableProductCard
}

const PopularInfoV1 = observer(({ productCard }: PopularInfoV1Props) => {
    return (
        <div className="popular-info-v1">
            {(
                productCard.countReviews != null 
                    &&
                productCard.countReviews > 0
            ) && (
                <div className="popular-info-v1__link">
                    <LinkV1
                        href="#tab-reviews"
                        label={`${productCard.countReviews} ${PluralFormat(productCard.countReviews, ['отзыв', 'отзыва', 'отзывов'])}`}
                        classes={['link-v1', 'link-v1_text-color-type-main', 'link-v1_decoration-type-none', 'animate-scroll-v1']}
                    />
                </div>
            )}
            {(
                productCard.countOrders != null 
                    && 
                productCard.countReviews != null
                    &&
                productCard.countOrders > 0
                    &&
                productCard.countReviews > 0
            ) && (
               <>|</>
            )}
            {(
                productCard.countOrders != null
                    &&
                productCard.countOrders > 0
            ) && (
                <div className="popular-info-v1__info">
                    {productCard.countOrders} {PluralFormat(productCard.countOrders, ['заказ', 'заказа', 'заказов'])}
                </div>
            )}
        </div>
    );
});

export default PopularInfoV1;